import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import config from "../../../config";

//redux
import {
  editPeriodoEvaluacion,
  deletePeriodoEvaluacion,
  savePeriodoEvaluacion,
  getPeriodoEvaluaciones,
} from "../../../redux/evaluacion_desempenio/periodo_evaluacion/actions";

//el nombre como llega en la api
const schema = Yup.object().shape({
  nombre: Yup.string().ensure().required("**Campo requerido"),
  descripcion: Yup.string().ensure().required("**Campo requerido"),
  //  cantidad_meses: Yup.number()
  //      .integer("El número no puede tener decimales.")
  //      .min(1, "El valor minimo es 1.")
  //      .max(12, "El valor maximo es 12.")
  //      .required("**Campo requerido"),
});

const PeriodoEvaluacion = (props) => {
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [periodos, setperiodos] = useState([]);
  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [isDisable, setIsDisable] = useState(false);

  const filters = [
    // { id: "nombre", desc: "Nombre" },
    { id: "descripcion", desc: "Descripción" },
  ];
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "descripcion",
    desc: "Descripción",
  });

  const [periodoSelect, setPeriodoSelect] = useState("");
  const [periodoInput, setPeriodoInput] = useState("");

  const dispatch = useDispatch();
  const periodoEvaluacionStore = useSelector(
    (store) => store.periodoEvaluacion
  );
  const {
    loaderPeriodoEvaluacion,
    periodoEvaluacion,
    periodoEvaluacionFalla,
    saveLoaderPeriodoEvaluacion,
    periodoEvaluacionFormError,
  } = periodoEvaluacionStore;

  //Datos para el custom table

  useEffect(() => {
    _getPeriodoEvaluacion();
    setperiodos(config.periodoEvaluacion);
  }, []);

  const pages = Math.ceil(
    periodoEvaluacion ? periodoEvaluacion.count / limit : 0
  );

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
    },
    //  {
    //     Header: "Cantidad de meses",
    //     accessor: "cantidad_meses",
    //  },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  const _getPeriodoEvaluacion = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getPeriodoEvaluaciones({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePeriodoEvaluacion(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPeriodoEvaluacion(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPeriodoEvaluacion(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    const existNombre = periodoEvaluacion.data.find(
      (e) => e.nombre === req.nombre
    );
    //const exist = periodoEvaluacion.data.find((e) => e.nombre.descripcion === req.nombre.descripcion);
    // console.log("info");
    // console.log("info2", exist);
    // debugger;
    if (existNombre && edit && existNombre.id !== editItem.id) {
      toastr.info("El periodo ya existe.");
      return;
    }
    if (existNombre && !edit) {
      toastr.info("El periodo ya existe.");
      return;
    }

    const temp = config.periodoEvaluacion.find((e) => e.nombre === req.nombre);
    req.cantidad_meses = 12 / temp.numero;
    if (!edit) {
      dispatch(savePeriodoEvaluacion(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editPeriodoEvaluacion(req, index, setShowFormModal));
    }
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              PERIODO EVALUACIÓN
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                {/* <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    {/* <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger> */}
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!periodoEvaluacionFalla && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {periodoEvaluacionFalla}
            </Alert>
          )}
          {loaderPeriodoEvaluacion ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : periodoEvaluacion != null && periodoEvaluacion.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={periodoEvaluacion.data}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={periodoEvaluacion.count}
                pages={pages}
                pagFunc={_getPeriodoEvaluacion}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nombre: edit ? editItem.nombre : "",
              descripcion: edit ? editItem.descripcion : "",
              // cantidad_meses: edit ? editItem.cantidad_meses : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar Periodo de evaluacion"
                      : "Crear Periodo de evaluacion"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {periodoEvaluacionFormError &&
                  typeof periodoEvaluacionFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {periodoEvaluacionFormError}
                    </Alert>
                  ) : null}
                  {/* <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Nombre
                    </Form.Label>
                    <Form.Control
                      name="nombre" //e.target.name : e.target.value || nombre: trimestre
                      className="rounded-pill"
                      required
                      disabled
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre"
                      onBlur={handleBlur("nombre")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {periodoEvaluacionFormError &&
                    typeof periodoEvaluacionFormError === "object" &&
                    periodoEvaluacionFormError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {periodoEvaluacionFormError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group> */}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Periodo
                    </Form.Label>
                    <Form.Control
                      //</Col> disabled={
                      //   (periodo && periodo.count === 0) ||
                      // (edit &&
                      //   editItem.list_estado[0].periodo.toLowerCase() ===
                      // "cerrado")
                      // }
                      as="select"
                      id="nombre"
                      name="nombre"
                      className="col rounded-pill"
                      onBlur={handleBlur("nombre")}
                      value={values.nombre}
                      onChange={(e) => handleChange(e)}
                      //isValid={touched.descripcion && !errors.descripcion}
                      //isInvalid={touched.descripcion && !!errors.descripcion}
                    >
                      <option>Seleccione un periodo</option>
                      {periodos &&
                        periodos.length > 0 &&
                        periodos.map((item) => (
                          <option key={item.id} value={item.nombre}>
                            {item.nombre}
                          </option>
                        ))}
                    </Form.Control>

                    {loaderPeriodoEvaluacion && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                    {!!periodoEvaluacionFalla && (
                      <Col>
                        <small className="text-danger">
                          **{periodoEvaluacionFalla}
                        </small>
                      </Col>
                    )}
                    {/*  {touched.periodo && errors.periodo && (
                                                <Col>
                                                    <small className="text-danger">{errors.periodo}</small>
                                                </Col>
                                            )}
                                            {!loaderPeriodoEvaluacion && periodo && periodo.count === 0 && (
                                                <Col>
                                                    <small className="text-danger">
                                                        **No se encontraron paises
                                                    </small>
                                                </Col>
                                            )}*/}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Descripción
                    </Form.Label>
                    <Form.Control
                      name="descripcion"
                      id="descripcion"
                      className="rounded"
                      //   type="text"
                      as="textarea"
                      value={values.descripcion}
                      placeholder="Descripción"
                      onBlur={handleBlur("descripcion")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {periodoEvaluacionFormError &&
                    typeof periodoEvaluacionFormError === "object" &&
                    periodoEvaluacionFormError.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {periodoEvaluacionFormError.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  {/*    <Form.Group as={Col} className="mb-3">
                                        <Form.Label column sm="12" md="12">
                                            Cantidad Meses
                                        </Form.Label>
                                        <Form.Control
                                            name="cantidad_meses"
                                            className="rounded-pill"
                                            required
                                            type="number"
                                            value={values.cantidad_meses}
                                            placeholder="0"
                                            //onBlur={handleBlur("cantidad_meses")}
                                            onChange={(e) => handleChange(e)}
                                            min={1}
                                            max={12}
                                            isInvalid={touched.cantidad_meses && !!errors.cantidad_meses}
                                        ></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.cantidad_meses}
                                        </Form.Control.Feedback>
                                        {periodoEvaluacionFormError &&
                                            typeof periodoEvaluacionFormError === "object" &&
                                            periodoEvaluacionFormError.cantidad_meses ? (
                                            <ul className="list-unstyled text-danger ml-2">
                                                {periodoEvaluacionFormError.cantidad_meses.map((item) => (
                                                    <li>{item}</li>
                                                ))}
                                            </ul>
                                        ) : null}
                                    </Form.Group>  */}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderPeriodoEvaluacion}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderPeriodoEvaluacion && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default PeriodoEvaluacion;
